import {ControllableDialog, DialogController} from "./index";

export default function setup(controller: DialogController): ControllableDialog {
	const element = document.getElementById("can-download-immediately");
	if (!element) {
		throw new Error();
	}
	let timeout: ReturnType<Window['setTimeout']>|undefined = undefined;

	const anchorHandler = () => {
		controller.close();
	};
	return {
		beforeShow() {
			if (timeout !== undefined) {
				window.clearTimeout(timeout);
			}
			for (const anchor of element.querySelectorAll<HTMLAnchorElement>("a.click-here")) {
				anchor.href = controller.activeHref!;
				anchor.addEventListener('click', anchorHandler);
			}
			timeout = window.setTimeout(() => {
				timeout = undefined;
				const anchor = element.querySelector<HTMLAnchorElement>("a.click-here");
				if (anchor) {
					anchor.click();
				} else {
					window.location.assign(controller.activeHref!);
				}
			});
		},
		beforeHide() {
			if (timeout !== undefined) {
				window.clearTimeout(timeout);
			}
		},
		afterHide() {
			for (const anchor of element.querySelectorAll<HTMLAnchorElement>("a.click-here")) {
				anchor.removeEventListener('click', anchorHandler);
			}
		}
	};
}
